import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/pt';

import { default as isDateFn } from 'date-fns/isDate';
import { default as dateFormat } from 'date-fns/format';
import { default as parseDateFormat } from 'date-fns/parse';
import { default as isValidFn } from 'date-fns/isValid';
import { formatDistanceStrict } from 'date-fns';

import { es, enGB, enUS, de, fr, it, pt, ru, ptBR, da } from 'date-fns/locale';

const DEFAULT_FORMAT = 'YYYY-MM-DDTHH:mm:SSS';
export const isValid = isValidFn;

export const LOCALE_DATES = {
    'es-ES': es,
    es: es,
    'en-GB': enGB,
    en: enGB,
    'en-US': enUS,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-PT': pt,
    'ru-RU': ru,
    'pt-BR': ptBR,
    'da-DK': da,
};

export const setupMomentLocale = (locale = 'en') => {
    moment.locale(locale);
};

export const getLocaleDateTime = (date, format = DEFAULT_FORMAT) =>
    moment(date, format).format('L hh:mm');

export const getLocaleDate = (date, format = DEFAULT_FORMAT) => moment(date, format).format('L');

export function formatDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return dateFormat(d, format, {
        locale: LOCALE_DATES[locale],
    });
}

export function formatDateWithFormat(date, locale = 'en-US', formatIn = 'P p', formatOut = 'P p') {
    let d = date;
    const jsDate = parseDateFormat(d, formatIn, 0, { locale: LOCALE_DATES[locale] });
    if (!isValid(jsDate)) return date;
    return formatDate(jsDate, locale, formatOut);
}

export const getTimeUntilNow = (date, locale = 'en-US') => {
    return formatDistanceStrict(new Date(date), new Date(), { locale: LOCALE_DATES[locale] });
};
